/* Oasly attribution (29.10.26, v2)
   1. Visit code: every page view gets a short random code, registered on PostHog as visit_id (with the
      source as wa_ref), so every event on the page carries both. PostHog itself records UTMs, click ids
      (gclid, gbraid, wbraid, fbclid, msclkid, ttclid), referrer and landing page.
   2. WhatsApp source, in plain words: the prefilled message gets one natural sentence from the dictionary
      below, e.g. "Hola Oasly, vi vuestro anuncio en Google. Me interesa. Mi código postal es:".
      HQ reads it back with the same dictionary (Supabase table wa_ref_dictionary, trigger
      set_contact_source_ref) into contacts.source_ref. Old "[ref X]" tags are removed from the links.
      A wa_handoff event (PostHog + GA4) records each click with the source and visit code, so HQ can
      match the chat to the website session by source + time.
   3. Shopify cart: hidden attributes _visit_id, _utm_*, _gclid…, _referrer, _landing, _source_tag on every
      add to cart (customer action), so they end up on the order.
   Nothing is written to cookies or storage, except the first campaign of the visit in sessionStorage
   when the visitor accepted statistics cookies (same rule as the original source tag).
   KEEP IN SYNC: the phrases below must match public.wa_ref_dictionary in Supabase. */
(function(){
  if (window.OaslyAttribution) return;
  var DICT = {
    'G-Ad':   { es: 'vi vuestro anuncio en Google', en: 'I saw your ad on Google', ca: 'he vist el vostre anunci a Google' },
    'IG-Ad':  { es: 'vi vuestro anuncio en Instagram', en: 'I saw your ad on Instagram', ca: 'he vist el vostre anunci a Instagram' },
    'FB-Ad':  { es: 'vi vuestro anuncio en Facebook', en: 'I saw your ad on Facebook', ca: 'he vist el vostre anunci a Facebook' },
    'GPT-Ad': { es: 'vi vuestro anuncio en ChatGPT', en: 'I saw your ad on ChatGPT', ca: 'he vist el vostre anunci a ChatGPT' },
    'GPT':    { es: 'os encontré a través de ChatGPT', en: 'I found you through ChatGPT', ca: 'us he trobat a través de ChatGPT' },
    'PPLX':   { es: 'os encontré a través de Perplexity', en: 'I found you through Perplexity', ca: 'us he trobat a través de Perplexity' },
    'GEM':    { es: 'os encontré a través de Gemini', en: 'I found you through Gemini', ca: 'us he trobat a través de Gemini' },
    'CLA':    { es: 'os encontré a través de Claude', en: 'I found you through Claude', ca: 'us he trobat a través de Claude' },
    'COP':    { es: 'os encontré a través de Copilot', en: 'I found you through Copilot', ca: 'us he trobat a través de Copilot' },
    'IG':     { es: 'os encontré en Instagram', en: 'I found you on Instagram', ca: 'us he trobat a Instagram' },
    'FB':     { es: 'os encontré en Facebook', en: 'I found you on Facebook', ca: 'us he trobat a Facebook' },
    'SEO':    { es: 'os encontré en Google', en: 'I found you on Google', ca: 'us he trobat a Google' },
    'WEB':    { es: 'os escribo desde vuestra web', en: "I'm writing from your website", ca: 'us escric des de la vostra web' }
  };
  var ABC = 'abcdefghjkmnpqrstuvwxyz23456789';
  function makeCode(){
    var s = '', r;
    try { r = crypto.getRandomValues(new Uint8Array(6)); } catch (x) { r = []; for (var j = 0; j < 6; j++) r.push(Math.floor(Math.random() * 256)); }
    for (var i = 0; i < 6; i++) s += ABC[r[i] % ABC.length];
    return s;
  }
  var VID = makeCode();
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid', 'gad_source', 'gad_campaignid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id', 'twclid', 'campaign_id', 'adset_id', 'ad_id'];
  var q = new URLSearchParams(location.search);
  var here = {};
  KEYS.forEach(function(k){ var v = q.get(k); if (v) here[k] = v.slice(0, 200); });
  var refHost = '';
  try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (x) {}
  if (refHost && /(^|\.)oasly\.(es|shop)$/.test(refHost)) refHost = '';

  function consented(){ try { return !!(window.Cookiebot && Cookiebot.consent && Cookiebot.consent.statistics); } catch (x) { return false; } }
  function firstTouch(){
    var hasHere = Object.keys(here).length > 0;
    if (consented()) {
      try {
        var saved = JSON.parse(sessionStorage.getItem('oasly_camp') || 'null');
        if (!saved && (hasHere || refHost)) { saved = { c: here, r: refHost, l: location.pathname }; sessionStorage.setItem('oasly_camp', JSON.stringify(saved)); }
        if (saved) return saved;
      } catch (x) {}
    }
    return { c: here, r: refHost, l: location.pathname };
  }

  function detect(){
    var u = (q.get('utm_source') || '').toLowerCase(), med = (q.get('utm_medium') || '').toLowerCase(), r = refHost;
    var paid = /cpc|ppc|paid|^ads?$|display|sponsored/.test(med) || !!(q.get('ad_id') || q.get('campaign_id') || q.get('adset_id'));
    if (u === 'chatgpt') return 'GPT-Ad';
    if (/chatgpt|openai/.test(u) || /chatgpt\.com|openai\.com/.test(r)) return 'GPT';
    if (/perplexity/.test(u + r)) return 'PPLX';
    if (/gemini/.test(u) || /gemini\.google/.test(r)) return 'GEM';
    if (/claude/.test(u) || /claude\.ai/.test(r)) return 'CLA';
    if (/copilot/.test(u + r)) return 'COP';
    if (q.get('gclid') || q.get('gbraid') || q.get('wbraid') || (u === 'google' && paid)) return 'G-Ad';
    if (q.get('fbclid') || /^(meta|fb|facebook|ig|instagram)$/.test(u) || /instagram|facebook/.test(r)) {
      var fb = /^(fb|facebook)$/.test(u) || (/facebook/.test(r) && !/instagram/.test(r));
      if (paid) return fb ? 'FB-Ad' : 'IG-Ad';
      return fb ? 'FB' : 'IG';
    }
    if (/(^|\.)(google|bing|duckduckgo|yahoo|ecosia|qwant|brave)\./.test(r)) return 'SEO';
    return null;
  }
  function source(){
    var s = detect();
    if (!s && consented()) { try { s = sessionStorage.getItem('oasly_src'); } catch (x) {} }
    return (s && DICT[s]) ? s : 'WEB';
  }

  /* PostHog super properties (memory only in cookieless mode) */
  var tries = 0;
  (function reg(){
    var ph = window.posthog;
    if (ph && ph.register) {
      try { ph.register({ visit_id: VID, wa_ref: source() }); } catch (x) {}
      if (ph.__loaded) return;
    }
    if (tries++ < 40) setTimeout(reg, 250);
  })();

  /* WhatsApp prefilled text */
  function lang(t){
    if (/\b(I'm|I have|Do you|My postal|question|booking)\b/i.test(t)) return 'en';
    if (/m'interessa|tinc una|codi postal|El meu/i.test(t)) return 'ca';
    if (/\b(me interesa|tengo una|código postal)\b/i.test(t)) return 'es';
    var l = (document.documentElement.getAttribute('lang') || 'es').slice(0, 2);
    return l === 'en' || l === 'ca' ? l : 'es';
  }
  function hasPhrase(t){
    var lt = t.toLowerCase();
    for (var k in DICT) for (var l in DICT[k]) if (lt.indexOf(DICT[k][l].toLowerCase()) > -1) return true;
    return false;
  }
  function cap(s){ return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function compose(t, src){
    t = (t || '').replace(/\s*\[ref [^\]]*\]/g, '');
    if (hasPhrase(t)) return t;
    var phrase = DICT[src][lang(t)];
    var m = t.match(/^\s*((?:Hola|Hi|Hello|Hey)\s+Oasly)\s*([,!.]?)\s*/i);
    if (!m) return t ? 'Hola Oasly, ' + phrase + '. ' + cap(t.trim()) : 'Hola Oasly, ' + phrase + '.';
    var rest = t.slice(m[0].length).trim();
    var punct = m[2] || ',';
    var p = punct === ',' ? phrase : cap(phrase);
    return m[1] + punct + ' ' + p + '.' + (rest ? ' ' + cap(rest) : '');
  }
  var WA = /(wa\.me\/|api\.whatsapp\.com)/i;
  function tagHref(h){
    try {
      var url = new URL(h, location.href);
      var t = url.searchParams.get('text') || '';
      var n = compose(t, source());
      if (n === t) return h;
      url.searchParams.set('text', n);
      return url.toString();
    } catch (x) { return h; }
  }
  function tagAll(){
    document.querySelectorAll('a[href*="wa.me/"], a[href*="api.whatsapp.com"]').forEach(function(a){
      var h = a.getAttribute('href') || '', n = tagHref(h);
      if (n !== h) a.setAttribute('href', n);
    });
  }
  function track(name, p){
    var d = Object.assign({ visit_id: VID, page_path: location.pathname }, p || {});
    try { window.gtag && gtag('event', name, Object.assign({ send_to: 'G-WRBYNKQD4H', transport_type: 'beacon' }, d)); } catch (x) {}
    try { window.posthog && window.posthog.capture && window.posthog.capture(name, d, { transport: 'sendBeacon' }); } catch (x) {}
  }
  var lastWa = 0;
  window.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    if (!WA.test(h)) return;
    var n = tagHref(h);
    if (n !== h) a.setAttribute('href', n);
    var now = Date.now(); if (now - lastWa < 1500) return; lastWa = now;
    track('wa_handoff', { ref: source(), link_text: (a.textContent || '').trim().slice(0, 60) });
  }, true);

  /* Shopify cart attributes on every add to cart */
  function cartAttrs(){
    var f = firstTouch(), o = { _visit_id: VID };
    Object.keys(f.c || {}).forEach(function(k){ o['_' + k] = f.c[k]; });
    if (f.r) o._referrer = f.r;
    if (f.l) o._landing = f.l;
    o._source_tag = source();
    return o;
  }
  var of = window.fetch;
  if (of) {
    window.fetch = function(input, init){
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
          var attrs = cartAttrs();
          if (typeof init.body === 'string') {
            var b = JSON.parse(init.body);
            b.attributes = Object.assign({}, attrs, b.attributes || {});
            init = Object.assign({}, init, { body: JSON.stringify(b) });
          } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            Object.keys(attrs).forEach(function(k){ if (!init.body.has('attributes[' + k + ']')) init.body.append('attributes[' + k + ']', attrs[k]); });
          }
        }
      } catch (x) {}
      return of.apply(this, arguments.length > 1 ? [input, init] : arguments);
    };
  }
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
    var attrs = cartAttrs();
    Object.keys(attrs).forEach(function(k){
      if (f.querySelector('input[name="attributes[' + k + ']"]')) return;
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'attributes[' + k + ']'; i.value = attrs[k]; f.appendChild(i);
    });
  }, true);

  window.OaslyAttribution = { visitId: VID, source: source, cartAttrs: cartAttrs, tagHref: tagHref, compose: compose, dictionary: DICT };
  function ready(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function(){ setTimeout(tagAll, 50); setTimeout(tagAll, 1500); setTimeout(tagAll, 4000); });
  window.addEventListener('CookiebotOnAccept', function(){ setTimeout(tagAll, 50); });
})();
